import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { ContainerWidthProvider } from '../../util/responsiveness/ContainerWidthContext';
import Flex from '../Flex';

import { getClassNames } from './AppLayout.styles.legacy';
import type { AppLayoutProps } from './AppLayout.types';
import AppLayoutContextProvider from './AppLayoutContextProvider';
import ContentContainerContextProvider from './ContentContainerContextProvider';

const AppLayout: FC<PropsWithChildren<AppLayoutProps>> = ({
  children,
  height = '100vh',
  disableNativePageScroll = false,
  openContentSidebarAriaLabel,
  closeContentSidebarAriaLabel,
  hasBackButton = false,
  hasOuterLeftNav = false,
  backgroundColor,
  removeContentPadding = false,
  pinnedCollapsibleRightRail = false,
  unifiedSidebar = false,
  reservedRightRailBottomSpace,
  isLeftNavCollapsed = false,
}) => (
  <ContainerWidthProvider>
    <AppLayoutContextProvider
      openContentSidebarAriaLabel={openContentSidebarAriaLabel}
      closeContentSidebarAriaLabel={closeContentSidebarAriaLabel}
      hasBackButton={hasBackButton}
      hasOuterLeftNav={hasOuterLeftNav}
      removeContentPadding={removeContentPadding}
      pinnedCollapsibleRightRail={pinnedCollapsibleRightRail}
      unifiedSidebar={unifiedSidebar}
      reservedRightRailBottomSpace={reservedRightRailBottomSpace}
      isLeftNavCollapsed={isLeftNavCollapsed}
    >
      <ContentContainerContextProvider>
        <Flex direction="column" className={getClassNames(height, disableNativePageScroll, backgroundColor).appLayout}>
          {children}
        </Flex>
      </ContentContainerContextProvider>
    </AppLayoutContextProvider>
  </ContainerWidthProvider>
);
export default AppLayout;
